<template>
  <section>
    <div class="bg-thank d-flex align-items-center">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-6 offset-lg-3">
            <div class="box-message text-center">
              <div class="card-body">
                <p style="line-height: 32px;">ขอขอบคุณที่สนใจบริการ Big Cleaning
                  ทางเจ้าหน้าที่ได้รับข้อมูลของคุณลูกค้าแล้ว
                  ภายใน 1-2 ชม. จะมีเจ้าหน้าที่ติดต่อกลับ เพื่อขอทราบข้อมูลเพิ่มเติม ขออภัยถ้าหากเกิดความล่าช้า</p>
                <p>ขอบพระคุณมากค่ะ</p>
                <button class="btn btn-info btn-block"
                        @click.prevent="$router.replace({ path: '/big-cleaning', replace: true })">
                  กลับ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
  export default {
    name: 'ThankUsingServiceBigCleaning',
    created () {
      window._tfa.push({ notify: 'event', name: 'complete_registration', id: 1490322 })
    }
  }
</script>

<style lang="scss" scoped>
  div.bg-thank {
    height: 600px;

    background-image: url('/static/img/bigCleaningNew/THANK.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
  }

  div.box-message {
    font-size: 24px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/information/ThankUsingServiceBigCleaning.vue